// frontend/src/recording/journalParse.js
//
// Parsning av AI-genererad journaltext till sektioner.
// Porterad från Notes MainContent.parseJournalNote — matchar rubrikrader
// EXAKT mot mallens sektionstitlar (litar på att backendens generering
// använder mallens rubriker).

/**
 * @param {string} text - Genererad journaltext
 * @param {string[]} allowedTitles - Mallens sektionstitlar (tom lista = fritt)
 * @returns {{title: string, content: string}[]}
 */
export function parseJournalNote(text, allowedTitles = []) {
  if (!text || !text.trim()) {
    return [];
  }

  const allowed = new Set(allowedTitles.map((t) => t.trim()));
  const lines = text.split('\n');
  const secs = [];
  let current = null;
  let i = 0;

  while (i < lines.length) {
    const line = lines[i].trim();

    if (line) {
      const isValidTitle = allowed.size === 0 || allowed.has(line);

      if (isValidTitle && !current) {
        current = { title: line, content: '' };
        i++;

        while (i < lines.length && lines[i]?.trim() === '') i++;

        while (i < lines.length) {
          const nextLine = lines[i].trim();
          const isNextValidTitle = allowed.size === 0 || allowed.has(nextLine);
          if (nextLine && isNextValidTitle) {
            break;
          }
          if (!nextLine && current.content.trim()) {
            i++;
            break;
          }
          current.content += lines[i] + '\n';
          i++;
        }

        secs.push(current);
        current = null;
      } else if (current) {
        current.content += line + '\n';
        i++;
      } else {
        if (secs.length === 0) {
          secs.push({ title: 'Okänt', content: line + '\n' });
        } else {
          secs[secs.length - 1].content += line + '\n';
        }
        i++;
      }
    } else {
      i++;
    }
  }

  return secs.map((s) => ({ title: s.title, content: s.content.trim() }));
}
